/* tslint:disable */
/* eslint-disable */
/**
 * Service joined APIs
 * This is the global API definition for all service apis.
 *
 * The version of the OpenAPI document: 1.2.4
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { InternalUserCommentResponseV3FromJSON, InternalUserCommentResponseV3ToJSON, } from './InternalUserCommentResponseV3';
import { CommonResponseCollectionPaginationFromJSON, CommonResponseCollectionPaginationToJSON, } from './CommonResponseCollectionPagination';
/**
 * Check if a given object implements the InternalUserCommentsList200Response interface.
 */
export function instanceOfInternalUserCommentsList200Response(value) {
    if (!('pagination' in value) || value['pagination'] === undefined)
        return false;
    if (!('data' in value) || value['data'] === undefined)
        return false;
    return true;
}
export function InternalUserCommentsList200ResponseFromJSON(json) {
    return InternalUserCommentsList200ResponseFromJSONTyped(json, false);
}
export function InternalUserCommentsList200ResponseFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'pagination': CommonResponseCollectionPaginationFromJSON(json['pagination']),
        'data': (json['data'].map(InternalUserCommentResponseV3FromJSON)),
    };
}
export function InternalUserCommentsList200ResponseToJSON(json) {
    return InternalUserCommentsList200ResponseToJSONTyped(json, false);
}
export function InternalUserCommentsList200ResponseToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'pagination': CommonResponseCollectionPaginationToJSON(value['pagination']),
        'data': (value['data'].map(InternalUserCommentResponseV3ToJSON)),
    };
}
